export default __webpack_public_path__ + "static/media/doc-empty.1eeca39e.svg";